export function parseUserAgent(ua: string | undefined | null) {
  const text = String(ua || '')
  const system =
    /Windows NT/i.test(text)
      ? 'Windows'
      : /Mac OS X|Macintosh/i.test(text)
        ? 'macOS'
        : /Android/i.test(text)
          ? 'Android'
          : /iPhone|iPad|iOS/i.test(text)
            ? 'iOS'
            : /Linux/i.test(text)
              ? 'Linux'
              : 'Unknown'

  const browser =
    /Edg\//i.test(text)
      ? 'Edge'
      : /OPR\//i.test(text)
        ? 'Opera'
        : /Chrome\//i.test(text)
          ? 'Chrome'
          : /Firefox\//i.test(text)
            ? 'Firefox'
            : /Safari\//i.test(text)
              ? 'Safari'
              : 'Unknown'

  return { system, browser }
}
